<template>

  <div id="app">

    <Carrito></Carrito>

    <div class="overlay-micarrito"></div>

    <header-partial v-if="showHeader"></header-partial>
    <header-checkout-partial v-if="showHeaderCheckout"></header-checkout-partial>

    <router-view :key="$route.fullPath"/>
    <footer-partial v-if="showFooter"></footer-partial>


  </div>


</template>

<script>

  import { mapGetters } from 'vuex';
  import HeaderPartial from "@/components/HeaderPartial";
  import HeaderCheckoutPartial from "@/components/HeaderCheckoutPartial";
  import FooterPartial from "@/components/FooterPartial";
  import Carrito from "@/components/Carrito";

  export default {
  name: 'App',
    components: {Carrito, FooterPartial, HeaderPartial, HeaderCheckoutPartial},
    computed:{
      ...mapGetters(['user','isLogged']),
      showHeader(){
        switch (this.$route.path) {
          case "/login":
          case "/register":
          case "/forgot":
          case "/cart":
          case "/shipment":
          case "/payment":
          case "/success/transferencia-bancaria":
            return false;
            break;
          default:
            return true;
        }
      },
        showHeaderCheckout(){
            switch (this.$route.path) {
                case "/cart":
                case "/shipment":
                case "/payment":
                case "/success/transferencia-bancaria":
                    return true;
                    break;
                default:
                    return false;
            }
        },
      showFooter(){
        switch (this.$route.path) {
            case "/login":
                return false; break;
            default:
                return true;
      }
    }

    },
    data(){
      return {

      }
    },
    mounted(){
        this.$store.dispatch('getUser', this)
        .then(() => {

          this.$store.dispatch("loadCartFromStorage", {}).then( () =>{
          });

        })
        .catch(err => {
          this.$store.dispatch('cleanCart');
          this.$store.dispatch('logout');
          this.$router.push({name: 'Login'});
        });




    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue